<template>
  <div>
    <div class="fm-flex fm-rela">
      <div
        style="
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        "
        @click="showPopover = true"
      ></div>
      <el-input
        :value="getSelectLabel"
        placeholder="请选择资金账户"
        style="width: 300px"
        suffix-icon="el-icon-arrow-right"
        readonly
      >
        <div
          slot="prefix"
          style="height: 100%"
          class="fm-center"
          v-if="value && value.name"
        >
          <el-image
            style="width: 18px; height: 18px"
            fit="cover"
            class="fm-margin-right-5 fm-center"
            :src="$jsTool.getFundAccountImageSrc(value.fundAccountTypeEnum)"
          ></el-image>
        </div>
      </el-input>
    </div>
    <el-dialog
      title="选择资金账户"
      append-to-body
      modal-append-to-body
      width="800px"
      close-on-click-modal
      close-on-press-escape
      :visible.sync="showPopover"
    >
      <el-form inline :model="searchData">
        <el-form-item>
          <el-input
            placeholder="名称/备注"
            clearable
            prefix-icon="el-icon-search"
            v-model="searchData.searchInputValue"
            style="width: 250px"
            @keyup.enter.native="changeAndSearch"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="账户类型">
          <EnumSelect
            enumName="FundAccountTypeEnum"
            :multiple="false"
            placeholder="请选择账户类型"
            v-model="searchData.fundAccountTypeEnum"
            @change="changeAndSearch"
          ></EnumSelect>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="changeAndSearch"
            :loading="searchLoading"
          >
            查询
          </el-button>
          <el-button
            icon="el-icon-refresh"
            size="mini"
            @click="resetAndSearch"
            :loading="searchLoading"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <el-form inline v-hasPermi="['fundaccount:manage:add']">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-plus"
          @click="showEditDialog()"
          v-hasPermi="['fundaccount:manage:add']"
        >
          新增
        </el-button>
      </el-form>
      <el-table
        v-loading="searchLoading"
        :data="searchRes && searchRes.data ? searchRes.data : []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        ref="refsTable"
        @sort-change="sortChange"
        max-height="400px"
      >
        <el-table-column
          prop="name"
          label="名称"
          width="200"
          align="left"
          header-align="center"
          sortable="custom"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="账户类型"
          width="150"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="fm-flex fm-center">
              <el-image
                style="width: 18px; height: 18px"
                fit="cover"
                class="fm-margin-right-5"
                :src="
                  $jsTool.getFundAccountImageSrc(scope.row.fundAccountTypeEnum)
                "
              ></el-image>
              {{ scope.row.fundAccountTypeEnum.Desc }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="250"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-fmtype="scope.row.remark ? '' : 'warning'">{{
              scope.row.remark || "——"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-thumb"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="searchRes && searchRes.pageInfo"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchRes.pageInfo.page"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="searchRes.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchRes.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      id="editDialog"
      :title="editInfo && editInfo.id ? '修改资金账户' : '新增资金账户'"
      :visible.sync="editDialogVisible"
      width="500px"
      append-to-body
      modal-append-to-body
      close-on-click-modal
      close-on-press-escape
    >
      <el-form
        :model="editInfo"
        label-position="right"
        label-width="100px"
        ref="editFormRef"
        :rules="{
          name: $ruleUtil.simple({
            fieldName: '资金账户名称',
            required: true,
            min: 2,
            max: 20,
          }),
          account: $ruleUtil.simple({
            fieldName: '资金账户账号',
            required: true,
            min: 2,
            max: 50,
          }),
          fundAccountTypeEnum: $ruleUtil.simple({
            fieldName: '账户类型',
            handleType: '选择',
            required: true,
          }),
          remark: $ruleUtil.simple({
            fieldName: '备注',
            required: false,
            max: 200,
          }),
        }"
        v-if="editInfo"
      >
      <el-form-item label="名称" prop="name">
          <el-input
            v-model="editInfo.name"
            placeholder="请输入资金账户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="account">
          <el-input
            v-model="editInfo.account"
            placeholder="请输入资金账户账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="账户类型" prop="fundAccountTypeEnum">
          <EnumSelect
            enumName="FundAccountTypeEnum"
            :multiple="false"
            placeholder="请选择账户类型"
            v-model="editInfo.fundAccountTypeEnum"
          ></EnumSelect>
        </el-form-item>
        <el-form-item label="期初余额" required v-if="!editInfo.id">
          <el-input-number
            style="width: 170px"
            v-model="editInfo.balanceAmount"
            size="small"
            :precision="2"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="默认标识" prop="defaultMark">
          <el-tooltip
            slot="label"
            content="设置此资金账户是否是默认资金账户，默认资金账户将会在选择页面自动带出"
            placement="top"
          >
            <span>
              <i class="el-icon-question"></i>
              默认标识
            </span>
          </el-tooltip>
          <el-radio-group v-model="editInfo.defaultMark">
            <el-radio :label="true">
              <span v-fmtype="'success'">默认</span>
            </el-radio>
            <el-radio :label="false">
              <span v-fmtype="'warning'">非默认</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            v-model="editInfo.remark"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="冻结状态" prop="frozen">
          <el-radio-group v-model="editInfo.frozen">
            <el-radio :label="false">
              <span v-fmtype="'success'">未冻结</span>
            </el-radio>
            <el-radio :label="true">
              <span v-fmtype="'danger'">已冻结</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editInfo = null">取 消</el-button>
        <el-button type="primary" @click="edit">
          {{ editInfo && editInfo.id ? "修 改" : "新 增" }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebFundAccountSelect",
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    getSelectLabel() {
      if (this.value && this.value.name) {
        return (
          "[" + this.value.fundAccountTypeEnum.Desc + "] " + this.value.name
        );
      }
    },
    editDialogVisible: {
      get() {
        return !!this.editInfo;
      },
      set(val) {
        if (!val) {
          this.editInfo = null;
        }
      },
    },
  },
  watch: {
    showPopover: {
      handler(newVal, val) {
        if (newVal) {
          this.searchData = this.$options.data().searchData; 
          this.searchParam = this.$options.data().searchParam; 
          this.search(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      showPopover: false,
      searchLoading: false,
      searchData: {
        searchInputValue: null,
        fundAccountTypeEnum: null,
        minBalance: null,
        maxBalance: null,
      },

      searchParam: {
        quickSearchInfoList: [
          {
            columns: ["name", "remark"],
            quickSearchValue: null,
          },
        ],
        fundAccountTypeEnum: null,
        minBalance: null,
        maxBalance: null,
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      searchRes: {},

      editInfo: null,
    };
  },

  mounted() {},

  methods: {
    select(item) {
      this.$emit("select", item);
      this.showPopover = false;
    },

    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.fundAccountTypeEnum =
        this.searchData.fundAccountTypeEnum;
      this.searchParam.minBalance = this.searchData.minBalance;
      this.searchParam.maxBalance = this.searchData.maxBalance;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.fundAccount_findPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },

    async showEditDialog(id) {
      this.editInfo = {
        name: null,
        account: null,
        fundAccountTypeEnum: null,
        defaultMark: false,
        remark: null,
        frozen: false,
        balanceAmount: "0.00",
      };
    },
    async edit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.editInfo.id
          ? await this.$api.fundAccount_update(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "修改中...",
              },
            })
          : await this.$api.fundAccount_addNew(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "新增中...",
              },
            });
        if (requestRes && requestRes.success) {
          this.editInfo = null;
          this.search();
        }
      });
    },
  },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/FundAccountSelectDialog.vue